
import * as React from "react"
import { logger } from "@/lib/logger"

const MOBILE_BREAKPOINT = 768

export function useIsMobile() {
  const [isMobile, setIsMobile] = React.useState<boolean | undefined>(undefined)

  React.useEffect(() => {
    const mql = window.matchMedia(`(max-width: ${MOBILE_BREAKPOINT - 1}px)`)
    const onChange = () => {
      setIsMobile(window.innerWidth < MOBILE_BREAKPOINT)
    }
    
    try {
      mql.addEventListener("change", onChange)
      setIsMobile(window.innerWidth < MOBILE_BREAKPOINT)
      
      return () => mql.removeEventListener("change", onChange)
    } catch (error) {
      logger.error('Mobile Detection', 'Failed to setup media query listener', error)
      // Fallback to initial detection
      setIsMobile(window.innerWidth < MOBILE_BREAKPOINT)
    }
  }, [])

  return !!isMobile
}
